<template>
  <div
    id="content"
    class="content"
    style="margin-left:0px;"
  >
    <h1
      class="page-header"
      style="text-align:left"
    >
      保证金管理
      <small>/ 保证金审核列表</small>
    </h1>
    <div
      id="page-container"
      class="in page-sidebar-fixed page-header-fixed"
      style="padding-top:0px;"
    >
      <!-- begin #content -->
      <div
        id="content"
        class="content"
        style="margin-left:0px;padding-top: 0px;padding-left:0px;padding-right:0px;"
      >
        <!-- begin breadcrumb -->
        <div class="row">
          <!-- begin col-10 -->
          <div class="col-lg-12">
            <!-- begin panel -->
            <div class="panel panel-inverse">
              <!-- begin panel-heading -->
              <div class="panel-heading">
                <div class="panel-heading-btn">
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-default"
                    data-click="panel-expand"
                  >
                    <i class="fa fa-expand"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-success"
                    data-click="panel-reload"
                  >
                    <i class="fa fa-redo"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-warning"
                    data-click="panel-collapse"
                  >
                    <i class="fa fa-minus"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-danger"
                    data-click="panel-remove"
                  >
                    <i class="fa fa-times"></i>
                  </a>
                </div>
                <h4 class="panel-title panelTitle">保证金审核列表</h4>
              </div>
              <!-- end panel-heading -->
              <div class="panel-body">
                <form style="margin-top:16px;">
                  <fieldset>
                    <div class="form-group row m-b-15">
                      <label class="col-md-1 col-form-label">合同编号</label>
                      <div class="col-md-2">
                        <input
                          type="text"
                          class="form-control"
                          placeholder="合同编号"
                          v-model="contractNo"
                        >
                      </div>
                      <label class="col-md-1 col-form-label">合同标题</label>
                      <div class="col-md-2">
                        <input
                          type="text"
                          class="form-control"
                          placeholder="合同标题"
                          v-model="contractTitle"
                        >
                      </div>
                      <label class="col-md-1 col-form-label">保证金缴纳时间</label>
                        <div class="col-md-3">
                          <el-date-picker
                            style="width:100%;height:34px;"
                            v-model="TimeValue"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            @change="ChangePicker"
                          ></el-date-picker>
                        </div>
                      <div class="col-md-2"></div>
                      <label class="col-md-1 col-form-label LineSpacing">服务商名称</label>
                      <div class="col-md-2 LineSpacing">
                        <el-select
                          v-model="recomId"
                          style="width:100%"
                          clearable
                          filterable
                          placeholder="服务商名称"
                        >
                          <el-option
                            v-for="item in recomList"
                            :key="item.recomId"
                            :label="item.recomName"
                            :value="item.recomId"
                          ></el-option>
                        </el-select>
                      </div>
                      <div class="col-md-1 LineSpacing">
                        <a
                          class="btn btn-primary ButtonColor m-r-5"
                          @click="SearchClick()"
                        >查询</a>
                      </div>
                      <div class="col-md-8"></div>
                      <div class="col-md-11"></div>
                    </div>
                  </fieldset>
                </form>
                <el-table :data="contractList" style="width: 100%" border>
                  <el-table-column width="50" prop="ordernumber" label="序号" align="center" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="contractNo" label="合同编号" align="center" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="contractTitle" label="合同标题" align="center" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="city" label="合同区域" align="center" show-overflow-tooltip></el-table-column>
<!--                  <el-table-column label="合同品类" align="center" show-overflow-tooltip>-->
<!--                    <template slot-scope="scope">-->
<!--                      <el-popover trigger="hover">-->
<!--                        <p-->
<!--                          v-for="(item,index) in scope.row.goodsNameList"-->
<!--                          :key="index"-->
<!--                        >{{item}}</p>-->
<!--                        <div-->
<!--                          slot="reference"-->
<!--                          class="name-wrapper SkuHover"-->
<!--                        >-->
<!--                          <span>{{ scope.row.goodsNameList[0] }} &nbsp;<b v-if=" scope.row.goodsNameList.length  > 1 ">...</b></span>-->
<!--                        </div>-->
<!--                      </el-popover>-->
<!--                    </template>-->
<!--                  </el-table-column>-->
                  <!-- <el-table-column prop="contractTerm" label="合同期限" align="center" show-overflow-tooltip></el-table-column> -->
                  <el-table-column prop="recomName" label="服务商" align="center" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="clientSignTime" label="合同签订日期" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="contractTerm" label="合同截止日期" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="deposit" label="保证金" align="center" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="depositTime" label="保证金缴纳时间" align="center" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="depositStatusName" label="状态" align="center" show-overflow-tooltip></el-table-column>
                  <el-table-column label="凭证" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                      <img
                        :src="scope.row.fileUrl"
                        alt=""
                        v-if="scope.row.fileUrl"
                        @click="EnlargeImg(scope.row)"
                        class="LogoImg"
                      >
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" width="200" align="center">
                    <template slot-scope="scope">
                      <el-button
                        class="btn btn-warning btn-sm ButtonColor"
                        size="small"
                        :disabled="scope.row.orderStatus == 2"
                        @click="ReviewClick(scope.row)"
                        >审核
                      </el-button>
                      <el-button
                        class="btn btn-primary btn-sm ButtonColor"
                        size="small"
                        @click="handleClick(scope.row)"
                        >合同详情
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <div class="PaginationStyle">
                  <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageindex"
                    :page-sizes="[10,20,50,100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    background
                    :total="totalCount"
                  ></el-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <el-dialog title :visible.sync="outerVisible" width="500px">
        <div v-if="EditDialog === 1" class="ModelPadding">
          <div class="swal-icon swal-icon--info"></div>
          <div class="swal-title">合同的时间、品类、区域、金额你确定了吗</div>
          <el-form :model="reasonValidForm" ref="reasonValidForm" label-width="100px" class="demo-ruleForm">
            <el-form-item
              label="上传凭证"
              prop="fileUrl"
              :rules="[
                { required: true, message: '请上传凭证',trigger: 'blur'}
              ]"
            >
              <el-upload
                class="avatar-uploader"
                action
                :show-file-list="false"
                :http-request="uploadPicture">
                <i v-if="imageUrl" class="el-icon el-icon-close"
                  @click.stop.self="() => {
                    imageUrl = ''
                    percentageShow = false
                    percentage = 0
                  }"
                />
                <img v-if="imageUrl" :src="imageUrl" class="avatar" />
                <i v-else class="el-icon-plus avatar-uploader-icon" />
              </el-upload>
              <el-progress :percentage="percentage" :status="percentagestatus" v-if="percentageShow"></el-progress>
              <span style="color: #F56C6C;font-size: 12px;" v-if="errorTip">必须上传图片</span>
            </el-form-item>
            <el-form-item
              label="驳回理由"
              prop="rejectReason"
              :rules="[
                { required: true, message: '驳回理由不能为空',trigger: 'blur'}
              ]"
            >
              <el-input placeholder="请输入驳回原因" v-model="reasonValidForm.rejectReason" clearable></el-input>
            </el-form-item>
          </el-form>
          <div class="swal-footer">
            <div class="swal-button-container">
              <div class="swal-button swal-button--confirm btn btn-primary" :disabled="disabled" @click="MakeSure('reasonValidForm')">同意审核</div>
            </div>
            <div class="swal-button-container">
              <div class="swal-button swal-button--cancel btn btn-warning"  @click="CancleSure('reasonValidForm')">拒绝审核</div>
            </div>
          </div>
        </div>
        <div v-if="EditDialog === 2" class="ModelPadding">
          <img :src="CurrentSelection.fileUrl" style="width:400px;">
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import Qs from "qs";
import axios from "axios";
import http from "../../common/http";
import MethodsBus from "../../common/methodBus";
import eventBus from "../../common/eventBus";
export default {
  name: "depositReviews",
  data() {
    return {
      outerVisible: false,
      disabled: false,
      EditDialog: 1,
      TimeValue: "",
      contractNo: "",
      contractTitle: "",
      recomId:'',
      CurrentSelection: [],
      recomList:[],
      pageSize: 10,
      totalCount: 0,
      pageindex: 1,
      startTime: "",
      endTime: "",
      contractList: [],
      director:0,
      reasonValidForm: {
        rejectReason: '',
        fileUrl: ''
      },

      imageUrl: '',
      errorTip: '',
      percentage: 0,
      percentageShow: false,
      percentagestatus: 'exception'
    };
  },
  mounted: function() {
    // if(this.$route.query.director){
    //   this.director = this.$route.query.director;
    // }
    this.initdata();
    this.getRecomList();
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageindex = 1;
      this.initdata();
    },
    handleCurrentChange(val) {
      this.pageindex = val;
      this.initdata();
    },

    // 图片上传
    uploadPicture (param) {
      this.imageUrl = URL.createObjectURL(param.file)
      const formData = new FormData()
      formData.append('file', param.file)
      let that = this
      const options = {
        url: 'distribution/FileController/uploadFileToFast',
        method: 'post',
        headers: {'Content-Type': 'multipart/form-data'},
        data: formData
      }
      axios(options).then(function (response) {
        if (response.data.code === 200) {
          that.reasonValidForm.fileUrl = response.data.data
          that.percentageShow = true
          setTimeout(() => {
            that.percentage = 100
            that.percentagestatus = 'success'
          }, 100)
        } else {
          http.handleEorrorCode(response, that)
        }
      }).catch(function (error) {
        http.handleHttpError(error, that)
      })
    },

    initdata() {
      let that = this;
      const options = {
        url: "/distribution/B2cTobDepositController/queryDepositByPage",
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        data: Qs.stringify({
          contractNo: that.contractNo,
          contractTitle: that.contractTitle,
          recomId: that.recomId,
          startContractTerm: that.startTime,
          endContractTerm: that.endTime,
          depositStatusList: [1],
          current: that.pageindex,
          size: that.pageSize,
          director: that.director
        })
      };
      axios(options)
        .then(response => {
          if (response.data.code == 200) {
            that.contractList = response.data.data.records;
            that.totalCount = response.data.data.total;
            for (var i in response.data.data.records) {
              response.data.data.records[i].ordernumber =
                Number((that.pageindex - 1) * that.pageSize) + Number(i) + 1;
              if (response.data.data.records[i].clientSignTime !== null) {
                response.data.data.records[i].clientSignTime = that.FormatAllDate(
                  response.data.data.records[i].clientSignTime
                ).slice(0,10);;
              } else {
                response.data.data.records[i].contractTerm = "";
              }
               if (response.data.data.records[i].contractTerm !== null) {
                response.data.data.records[i].contractTerm = that.FormatAllDate(
                  response.data.data.records[i].contractTerm
                ).slice(0,10);;
              } else {
                response.data.data.records[i].contractTerm = "";
              }
              if (response.data.data.records[i].depositStatus == 1) {
                response.data.data.records[i].depositStatusName = "待审核";
              } else if (response.data.data.records[i].depositStatus == 0) {
                response.data.data.records[i].depositStatusName = "审核拒绝";
              } else if (response.data.data.records[i].depositStatus == 2) {
                response.data.data.records[i].depositStatusName = "审核通过";
              } else {
                response.data.data.records[i].depositStatusName = "状态异常";
              }
            }
          } else {
            http.handleHttpError(error, that);
          }
        })
        .catch(function(error) {
          http.handleHttpError(error, that);
        });
    },
    // 获取服务商列表
    getRecomList() {
      let that = this;
      const options = {
        url: "distribution/B2cRecomInfoController/getRecomInfoByCompany",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
          director: that.director
        })
      };
      axios(options).then(function(response) {
        if (response.data.code == 200) {
          that.recomList = response.data.data;
        } else {
          http.handleEorrorCode(response,that);
        }
      })
       .catch((error) => {
          http.handleHttpError(error, that);
        });
    },
    SearchClick() {
      this.pageNo = 1;
      this.initdata();
    },
    EnlargeImg(row) {
      this.EditDialog = 2;
      this.outerVisible = true;
      this.CurrentSelection = row;
    },
    handleClick(row, index) {
      this.$router.push({
        path: "/depositdetail",
        query: {
          contractId: row.contractId,
          fileUrl: row.fileUrl,
          deposit: row.deposit,
          depositTime: row.depositTime,
          checkId: 1
        }
      });
    },
    ReviewClick(row) {
      this.outerVisible = true;
      this.EditDialog = 1;
      this.CurrentSelection = row;
    },
    MakeSure (formName) {
      this.$refs[formName].validateField('fileUrl', (err) => {
        if (!err) {
          let that = this
          that.disabled = true
          const options = {
            url: '/distribution/B2cTobDepositController/checkDeposit',
            method: 'post',
            headers: {'Content-Type': 'application/x-www-form-urlencoded'},
            data: Qs.stringify({
              depositId: that.CurrentSelection.depositId,
              depositStatus: 2,
              fileUrl: this.reasonValidForm.fileUrl
            })
          }
          axios(options).then(function (response) {
            that.outerVisible = false
            that.disabled = false
            if (response.data.code == 200) {
              that.initdata()
              that.$notify({
                title: '成功',
                message: response.data.message,
                type: 'success'
              })
            } else {
              http.handleEorrorCode(response, that)
            }
          })
            .catch((error) => {
              that.outerVisible = false
              http.handleHttpError(error, that)
            })
        }
      })
    },
    CancleSure(formName){
      this.$refs[formName].validateField('rejectReason', (err) => {
        if (!err) {
          let that = this;
          that.disabled = true;
          const options = {
            url: "/distribution/B2cTobDepositController/checkDeposit",
            method: "post",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            data: Qs.stringify({
              depositId: that.CurrentSelection.depositId,
              depositRemark: that.reasonValidForm.rejectReason,
              depositStatus: 0
            })
          };
          axios(options).then(function(response) {
            that.outerVisible = false;
            that.disabled = false;
            if (response.data.code === 200) {
              that.initdata();
              that.$notify({
                title: "成功",
                message: response.data.message,
                type: "success"
              });
            } else {
              http.handleEorrorCode(response, that);
            }
          })
          .catch(error => {
            that.outerVisible = false;
            http.handleHttpError(error, that);
          });
        }
      });
    },
    ChangePicker() {
      if (this.TimeValue !== null) {
        this.startTime = this.FormatAllDate(this.TimeValue[0]);
        this.endTime = this.FormatAllDate(this.TimeValue[1]);
      } else if (this.TimeValue === null) {
        this.startTime = "";
        this.endTime = "";
      }
    },
    FormatAllDate(sDate) {
      var date = new Date(sDate);
      var seperator1 = "-";
      var seperator2 = ":";
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var seconds = date.getSeconds();
      //月
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      //日
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      //时
      if (hours >= 0 && hours <= 9) {
        hours = "0" + hours;
      }
      //分
      if (minutes >= 0 && minutes <= 9) {
        minutes = "0" + minutes;
      }
      //秒
      if (seconds >= 0 && seconds <= 9) {
        seconds = "0" + seconds;
      }
      //格式化后日期为：yyyy-MM-dd HH:mm:ss
      var currentdate =
        date.getFullYear() +
        seperator1 +
        month +
        seperator1 +
        strDate +
        " " +
        hours +
        seperator2 +
        minutes +
        seperator2 +
        seconds;

      return currentdate;
    },
    FormatSpecialDate(sDate) {
      var date = new Date(sDate);
      var seperator1 = "-";
      var seperator2 = ":";
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var seconds = date.getSeconds();
      //月
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      //日
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      //时
      if (hours >= 0 && hours <= 9) {
        hours = "0" + hours;
      }
      //分
      if (minutes >= 0 && minutes <= 9) {
        minutes = "0" + minutes;
      }
      //秒
      if (seconds >= 0 && seconds <= 9) {
        seconds = "0" + seconds;
      }
      //格式化后日期为：yyyy-MM-dd HH:mm:ss
      var currentdate =
        date.getFullYear() + seperator1 + month + seperator1 + strDate;

      return currentdate;
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.clear {
  clear: both;
}
.PaginationStyle {
  float: right;
  margin-top: 8px;
}
.left {
  margin-left: 15px;
}
.upload {
  margin-top: 20px;
  margin-left: 13%;
  display: flex;
  justify-content: flex-start;
}
.shangchuang {
  margin-left: 20px;
}
.upload_left {
  /* margin-top: 50px; */
  margin-left: 50px;
  padding-right: 30px;
  letter-spacing: 1px;
  font-weight: bold;
}
/*  */
.panelTitle {
  padding-left: 15px;
  text-align: left;
}
.ButtonColor {
  color: #fff !important;
}
.ModelPadding {
  margin-top: -20px;
}
.LineSpacing {
  margin-top: 16px;
}
.InputWidth {
  width: 202px;
}
.LogoImg {
  width: 100px;
  height: 100px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader img{
  max-width: 200px;
  max-height: 200px;
}
.avatar-uploader .el-icon-close{
  font-size: 42px;
  line-height: 42px;
  display: inline-block;
  margin-top: -6px;
  float: right;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 150px;
  text-align: center;
  border: 1px dashed #8c939d;
}
</style>



// WEBPACK FOOTER //
// src/components/ContractManagement/depositReviews.vue